import {
    Box,
    Chip,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Tooltip,
} from "@material-ui/core";
import React, { useState, useEffect } from "react";
import VisibilityIcon from "@material-ui/icons/Visibility";
import stringUtils from "../../utils/stringUtils";
import { Link } from "react-router-dom";
import MaskUtils from "../../utils/maskUtils";

const TableEmpresas = (props) => {
    const [rows, setRows] = useState([]);
    const [total, setTotal] = useState(0);
    const [pagina, setPagina] = useState(0);

    useEffect(async () => {
        setRows(props.rows);
    }, [props.rows]);
    useEffect(async () => {
        setTotal(props.total);
    }, [props.total]);
    useEffect(async () => {
        setPagina(props.pagina);
    }, [props.pagina]);

    const padding = props.padding ? props.padding : 12;

    const emptyRows = 10 - Math.min(10, rows.length);

    return (
        <Paper>
            <TableContainer>
                <Table aria-label="sticky table" sx={{ minHeight: "38rem" }}>
                    <TableHead>
                        <TableRow>
                            <TableCell align="center">
                                <Box color="primaryDark.main">
                                    <b>#Id</b>
                                </Box>
                            </TableCell>
                            <TableCell align="center">
                                <Box color="primaryDark.main">
                                    <b>Razão Social</b>
                                </Box>
                            </TableCell>
                            <TableCell align="center">
                                <Box color="primaryDark.main">
                                    <b>CNPJ</b>
                                </Box>
                            </TableCell>
                            <TableCell align="center">
                                <Box color="primaryDark.main">
                                    <b>Nome Fantasia</b>
                                </Box>
                            </TableCell>
                            <TableCell align="center">
                                <Box color="primaryDark.main">
                                    <b>Ações</b>
                                </Box>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row) => {
                            return (
                                <TableRow
                                    hover
                                    role="checkbox"
                                    tabIndex={-1}
                                    key={row.id}
                                >
                                    <TableCell
                                        align="center"
                                        style={{ padding: padding }}
                                    >
                                        <Chip size="small" label={row.id} />
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        style={{ padding: padding }}
                                    >
                                        <Box fontSize={13}>
                                            {row.razao_social}
                                        </Box>
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        style={{ padding: padding }}
                                    >
                                        <Box fontSize={13}>
                                            {MaskUtils.cnpjMask(row.cnpj)}
                                        </Box>
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        style={{ padding: padding }}
                                    >
                                        <Box fontSize={13}>
                                            {row.nome_fantasia}
                                        </Box>
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        style={{ padding: padding }}
                                    >
                                        <Tooltip title="Visualizar">
                                            <IconButton
                                                component={Link}
                                                to={`/empresas/cadastro/${row.id}`}
                                                aria-label="visualizar"
                                                size="small"
                                                height={11}
                                                width={11}
                                            >
                                                <VisibilityIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                        {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                                <TableCell colSpan={7} />
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[]}
                component="div"
                count={parseInt(total)}
                rowsPerPage={10}
                page={parseInt(pagina)}
                onChangePage={props.handleChangePage}
            />
        </Paper>
    );
};

export default TableEmpresas;
